
import { trans } from "@/globals/translator";

import { defineComponent, ref, computed } from "vue";
import Navbar, { NavLink } from "./Navbar.vue";
import AsideMenu from "@moonlight/vue3/components/AsideMenu.vue";
import ListGroup from "@moonlight/vue3/components/ListGroup.vue";
import ListItem from "@moonlight/vue3/components/listGroup/ListItem.vue";
import ListGroupHeader from "@moonlight/vue3/components/listGroup/ListGroupHeader.vue";
import ListItemText from "@moonlight/vue3/components/listGroup/ListItemText.vue";
import ListItemIcon from "@moonlight/vue3/components/listGroup/ListItemIcon.vue";
import ListGroupSeparator from "@moonlight/vue3/components/listGroup/ListGroupSeparator.vue";
import Avatar from "@moonlight/vue3/components/Avatar.vue";
import Dropdown from "@moonlight/vue3/components/Dropdown.vue";

import Icon from "@moonlight/vue3/components/Icon.vue";
import Button from "@moonlight/vue3/components/Button.vue";

import { useRouter } from "vue-router";
import useAuthUser from "@/composables/useAuthUser";
import { createImagesService } from "@/services/images-service/ImagesService";

export default defineComponent({
  components: {
    Dropdown,
    Avatar,
    Navbar,
    NavLink,
    Icon,
    AsideMenu,
    ListGroup,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListGroupSeparator,
    Button,
    ListGroupHeader,
  },
  setup() {
    const { authUser, isFetchingAuthUser, logout } = useAuthUser();
    const router = useRouter();
    const isOpenAsideMenu = ref(false);
    function toggleOpenAsideMenu() {
      isOpenAsideMenu.value = !isOpenAsideMenu.value;
    }
    function navigateTo(to: string) {
      if (to.startsWith("http")) {
        window.location.href = to;
      } else {
        router.push({ name: to });
      }
      isOpenAsideMenu.value = false;
    }

    const imageAvatar = computed(() => {
      const imagesService = createImagesService();
      const imageSizes = imagesService.getImageSizes(
        authUser.value?.imageAvatar as string,
        imagesService.AspectRatio.UserAvatar
      );

      return imageSizes.getClosestImageSize({ width: 32 }).src;
    });

    const isDropdownOpen = ref(false);

    const configurationLink = process.env.VUE_APP_FILMIN_WEB_CONFIGURATION_LINK;

    return {
      isDropdownOpen,
      authUser,
      logout,
      imageAvatar,
      isFetchingAuthUser,
      isOpenAsideMenu,
      toggleOpenAsideMenu,
      navigateTo,
      trans,
      links: [
        {
          text: trans("general.premieres"),
          to: "Medias",
        },
        {
          text: trans("general.cinema_premieres"),
          to: "CineMedias",
        },
        {
          text: trans("general.news"),
          to: "News",
        },
        {
          text: trans("general.about"),
          to: "https://comunidadfilmin.com/",
        },
      ],
      configurationLink,
    };
  },
});
